module.exports = __webpack_public_path__ + "assets/img/a.a76005ce.jpg";